import { calculatePercentage } from "../util/percentageUtils";
export const getSalesPercentage = (aggregatedSales) => {
    const { totalTicketsSalesToday, totalSales } = aggregatedSales.salesData;
    return calculatePercentage(totalTicketsSalesToday, totalSales);
};
export const getTicketsPercentage = (aggregatedSales) => {
    const { totalTicketsSoldToday, ticketsSold } = aggregatedSales.salesData;
    return calculatePercentage(totalTicketsSoldToday, ticketsSold);
};
//# sourceMappingURL=utils.js.map